import { atom } from 'jotai';
import { withHistory } from 'jotai-history';
const historyLimit = 20;
export const boardStateAtom = atom({ layers: [] });
export const historyBoardStateAtom = withHistory(boardStateAtom, historyLimit);
export const roleAtom = atom('GM');
export const stageViewportAtom = atom({
    zoom: 1,
    position: { x: 0, y: 0 },
    size: { width: window.innerWidth, height: window.innerHeight },
});
export const showGridAtom = atom(true);
export const snapToGridAtom = atom(true);
export const snapToGuidesAtom = atom(true);
export const gridSizeAtom = atom(50);
export const stageModeAtom = atom('select');
export const inputModeAtom = atom('trackpad');
export const selectedIdsAtom = atom([]);
export const intersectionsIdsAtom = atom([]);
export const draftSelectionIdsAtom = atom([]);
export const isSelectingAtom = atom(false);
export const selectionRectAtom = atom(null);
export const isPanningAtom = atom(false);
export const pointerPositionAtom = atom(null);
export const stageRefAtom = atom(null);
export const isZoomingAtom = atom(false);
// Атомы для режима презентации
export const presentationModeAtom = atom(false);
export const presentationElementIdAtom = atom(null);
export const presentationBoundsAtom = atom(null);
export const presentationZoomAtom = atom(1);
export const presentationPositionAtom = atom({ x: 0, y: 0 });
export const presentationViewChangedAtom = atom(false);
export const presentationElementsAtom = atom([]);
// Атом для редактора маски
export const maskEditorAtom = atom({ active: false, element: null, mode: 'rect', rect: null, circle: null });
// Атом для редактора кропа изображения
export const imageCropEditorAtom = atom({ active: false, element: null });
// Атом для попапа описания элемента
export const descriptionPopupElementIdAtom = atom(null);
// Атом для отслеживания перемещаемых элементов (для скрытия иконок)
export const movingElementsIdsAtom = atom([]);
// Атом для состояния линейки
export const rulerStateAtom = atom({
    isActive: false,
    startPoint: null,
    endPoint: null,
    distance: null,
    unit: 'px',
});
